export default {
    methods: {
        displayApiError(error) {
            let message = error.response.data.message;
            if (Array.isArray(message)) {
                message = message.join(', ');
            }
            this.$alert(message, '에러가 발생하였습니다.', {
                confirmButtonText: '확인',
                type: 'error',
            });
        },
    },
};